import React from 'react';
import { GiftsAndPreferencesFieldset } from '@/features/Collaborators/Edit/Form/Fieldsets';
import { CollaboratorFormContext } from "@/features/Collaborators/Edit/Contexts/CollaboratorFormContext";

interface MarketingTabProps {
    context: CollaboratorFormContext;
}

const MarketingTab: React.FC<MarketingTabProps> = ({ context }) => {
    return (
        <div className="space-y-6">
            <GiftsAndPreferencesFieldset
                context={context}
            />
        </div>
    );
};

export default MarketingTab;
